import { Currency } from './../../currency/objects/currency';
import { CategoryDetail } from "../objects/categoryDetail";
import { Column } from "../objects/column";
import { SaleBillParameters } from "../objects/saleBill";
import { InvoiceDocument, SalesReceipt } from "../objects/salesReceipt";
import { SalesReceiptErrors } from "../objects/salesReceiptErrors";
import { SalesReceiptListConfiguration } from "../objects/salesReceiptListConfiguration";
import { SalesReceiptListCriteria } from "../objects/salesReceiptListCriteria";
import { SalesReceiptListFiltersCriteria } from "../objects/salesReceiptListFiltersCriteria";
import { SalesReceiptInvoiceListCriteria } from "../objects/salesReceiptInvoiceListCriteria";
import { SalesReceiptInvoiceListFiltersCriteria } from "../objects/salesReceiptInvoiceListFiltersCriteria";
import { SalesReceiptClientListCriteria } from "../objects/salesReceiptClientListCriteria";
import { SalesReceiptClientListFiltersCriteria } from "../objects/salesReceiptClientListFiltersCriteria";
import { InvoiceProduct, InvoiceProductColumn } from "../objects/invoiceProduct";
import { BillPayment } from '../objects/billPayment';
import { getDefaultCurrency } from '../../../functions/getDefaultCurrency';
import { SalesReceiptPaidListCriteria } from '../objects/salesReceiptPaidListCriteria';
import { SalesReceiptPaidListFiltersCriteria } from '../objects/salesReceiptPaidListFiltersCriteria';
import { SalesStats } from '../objects/salesStats';
import { SalesReceiptThirdPartyListCriteria, ThirdPartyListFiltersCriteria } from '../objects/salesReceiptThirdPartyList';
import { ThirdParty } from '../objects/thirdParty';


const subDomain = window.location.host.split('.')[0];

export const EMPTY_CURRENCY: Currency = getDefaultCurrency();

export const EMPTY_SALES_STATS: SalesStats = {
    not_invoiced_count: 0,
    not_invoiced_amount: 0,
    late_invoice_count: 0,
    late_invoice_amount: 0,
    waiting_pay_count: 0,
    waiting_pay_amount: 0,
    paid_invoice_count: 0,
    paid_invoice_amount: 0
};

export const EMPTY_SALES_BILL_PARAMETERS: SaleBillParameters = {
    start_date: true,
    invoice_date: true,
    invoice_number: true,
    proforma_number: true,
    trip_reference: true,
    insurance_contract: true,
    due_date: true,
    payment_delay: true,
    einvoice_currency: true,
    currency: true,
    factor_used: true,
    destination: true,
    passenger_names: true,
    billing_period: true,
    name: true,
    description: true
};

export const EMPTY_CATEGORY_DETAIL: CategoryDetail = {
    category: "",
    description: "",
    amount: "",
    reconciled: false
};

export const EMPTY_INVOICE_PRODUCT: InvoiceProduct = {
    total_without_tax: "",
    flight_tax: "",
    total_amount: "",
    additional_info: {},
    creator: null,
    last_author: null,
    invoice: 0,
    trip_reference: '',
    contract_reference: '',
    category: '',
    destination_name: '',
    quantity: "",
    unit_price: '',
    start_date: null,
    total_amount_in_client_currency: ''
};

export const EMPTY_INVOICE_DOCUMENT: InvoiceDocument = {
    type: "PROFORMA",
    bucket_name: "",
    bucket_region: "",
    object_name: "",
    requested: false,
    received: false,
    file_name: null,
    display_voucher: false,
    display_minisite: false,
    trip: null,
    trip_version: null,
    traveler: undefined,
    product: undefined,
    hotel: undefined
};

export const EMPTY_SALES_RECEIPT: SalesReceipt = {
    id: 0,
    is_automatic: false,
    product_start_date: null,
    invoice_date: new Date(),
    export_date: null,
    due_date: null,
    payment_delay: null,
    currency: { ...EMPTY_CURRENCY },
    balance: "",
    amount: "",
    paid_amount: '',
    to_paid_amount: '',
    is_paid: false,
    factor_used: 1,
    trip: null,
    trip_version: null,
    creator: null,
    last_author: null,
    note: '',
    files: [],
    attachments: [],
    invoice_number: "",
    passenger_names: [],
    destination: null,
    einvoice_currency: { ...EMPTY_CURRENCY },
    trip_reference: 0,
    destination_name: '',
    nb_pax: null,
    invoice_product: [{ ...EMPTY_INVOICE_PRODUCT }],
    invoice_type: "PROFORMA",
    done_payments: null,
    document: EMPTY_INVOICE_DOCUMENT,
    is_generated: false,
    linked_invoice: null,
    send_date: null,
    billing_period_end_date: null,
    billing_period_start_date: null,
    name: '',
    description: '',
    proforma_number: '',
    sender_name: '',
    sender_street: '',
    sender_street2: '',
    sender_city: '',
    sender_country: '',
    sender_zip_code: '',
    sender_contact: '',
    sender_email: '',
    sender_phone_number: '',
    sender_logo: null,
    receiver_name: '',
    receiver_street: '',
    receiver_street2: '',
    receiver_city: '',
    receiver_country: '',
    receiver_zip_code: '',
    receiver_contact: '',
    receiver_email: '',
    receiver_phone_number: '',
    proforma_ids: [],
    target_client: null,
    for_user: null,
    fictitious_client: null,
    sent_date: null,
    reminder_date: null,
    insurance_contract: null,
    credit_note_number: ''
};

export const EMPTY_SALES_RECEIPT_FILTERS: SalesReceiptListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    invoice_type: 'CREDIT_NOTE,PROFORMA',
    period_type: 12,
    status: 'ALL',
    clients: [],
    period: "MODIFICATION",
    insurance_contract__contracts_type__name__unaccent__icontains: '',
    trip__event_site__in: []
};

export const EMPTY_SALES_RECEIPT_LIST_CRITERIA: SalesReceiptListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'desc',
    filters: EMPTY_SALES_RECEIPT_FILTERS,
    search: ''
};

export const EMPTY_SALES_RECEIPT_CLIENT_FILTERS: SalesReceiptClientListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_SALES_RECEIPT_CLIENT_LIST_CRITERIA: SalesReceiptClientListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_SALES_RECEIPT_CLIENT_FILTERS,
    search: ''
};

export const EMPTY_SALES_RECEIPT_INVOICE_FILTERS: SalesReceiptInvoiceListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 12,
    invoice_type: 'INVOICE,CREDIT_NOTE',
    period: "MODIFICATION",
    status: 'ALL',
    clients: [],
    insurance_contract__contracts_type__name__unaccent__icontains: '',
    trip__event_site__in: []
};


export const EMPTY_SALES_RECEIPT_INVOICE_LIST_CRITERIA: SalesReceiptInvoiceListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_SALES_RECEIPT_INVOICE_FILTERS,
    search: ''
};

export const EMPTY_SALES_RECEIPT_PAID_FILTERS: SalesReceiptPaidListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 12,
    period: "MODIFICATION",
    payment_type: 'undefined',
    clients: []
};


export const EMPTY_SALES_RECEIPT_PAID_LIST_CRITERIA: SalesReceiptPaidListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_SALES_RECEIPT_PAID_FILTERS,
    search: ''
};

export const EMPTY_SALES_RECEIPT_ERRORS: SalesReceiptErrors = {
    code_error: "",
    due_date_error: "",
    trip_error: "",
    invoice_error: ""
};

export const EMPTY_BILL_PAYMENT: BillPayment = {
    id: 0,
    bills: [],
    payment_grouping: [],
    payment_type: 'RM RGT1',
    done_date: new Date(),
    target_client: null,
    fictitious_client: null,
    for_user: null,
    identifier: "",
    paid: false,
    amount: "",
    balance: "",
    paid_amount: "",
    creator: null,
    last_author: null,
    description: '',
    trip_reference: '',
    trip: '',
    currency: null,
    accounting_client_payment: null,
    insurance_contract: null,
};

export const DEFAULT_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'invoice_type',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'proforma_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'client',
        field_name: 'CLIENT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'departs-the',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: false,
        order_by: 'destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'pax-number',
        field_name: 'PAX_NUMBER',
        checked: false,
        order_by: 'pax_number',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'due',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'due_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'sent-date',
        field_name: 'SENT_DATE',
        checked: false,
        order_by: 'sent_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'reminder-date',
        field_name: 'REMINDER_DATE',
        checked: false,
        order_by: 'reminder_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'opening-balance',
        field_name: 'BALANCE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];
export const DEFAULT_TOURIST_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'invoice_type',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'proforma_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'client',
        field_name: 'CLIENT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'identity-card-number',
        field_name: 'ID_CODE',
        checked: true,
        order_by: 'id_code',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'departs-the',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: false,
        order_by: 'destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'pax-number',
        field_name: 'PAX_NUMBER',
        checked: false,
        order_by: 'pax_number',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'due',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'due_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'sent-date',
        field_name: 'SENT_DATE',
        checked: false,
        order_by: 'sent_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'reminder-date',
        field_name: 'REMINDER_DATE',
        checked: false,
        order_by: 'reminder_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'opening-balance',
        field_name: 'BALANCE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];

export const DEFAULT_VA_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'invoice_type',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'proforma_number',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'reference',
        field_name: 'REFERENCE',
        checked: true,
        order_by: 'insurance_contract__reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'subscription-method',
        field_name: 'SUBSCRIPTION_METHOD',
        checked: true,
        order_by: 'insurance_contract__contracts_type__name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'client',
        field_name: 'CLIENT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'departs-the',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: false,
        order_by: 'destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'pax-number',
        field_name: 'PAX_NUMBER',
        checked: false,
        order_by: 'pax_number',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'due',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'due_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'sent-date',
        field_name: 'SENT_DATE',
        checked: false,
        order_by: 'sent_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'reminder-date',
        field_name: 'REMINDER_DATE',
        checked: false,
        order_by: 'reminder_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'opening-balance',
        field_name: 'BALANCE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];
export const CLIENT_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'company-name',
        field_name: 'COMPANY_NAME',
        checked: true,
        order_by: 'company_name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'phone-number',
        field_name: 'PHONE',
        checked: true,
        order_by: 'phone_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'opening-balance',
        field_name: 'OPENING_BALANCE',
        checked: true,
        order_by: 'opening_balance',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];


export const INVOICE_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'invoice_type',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'invoice_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'client',
        field_name: 'CLIENT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'invoice-date',
        field_name: 'INVOICE_DATE',
        checked: true,
        order_by: 'invoice_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'due',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'due_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'sent-date',
        field_name: 'SENT_DATE',
        checked: false,
        order_by: 'sent_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'reminder-date',
        field_name: 'REMINDER_DATE',
        checked: false,
        order_by: 'reminder_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    // {
    //     label: 'departs-the',
    //     field_name: 'DEPARTURE_DATE',
    //     checked: true,
    //     order_by: 'product_start_date',
    //     fixed_width: false,
    //     last_updated: false
    // },
    // {
    //     label: 'destination',
    //     field_name: 'DESTINATION',
    //     checked: false,
    //     order_by: 'destination',
    //     fixed_width: false,
    //     last_updated: false
    // },
    // {
    //     label: 'pax-number',
    //     field_name: 'PAX_NUMBER',
    //     checked: false,
    //     order_by: 'pax_number',
    //     fixed_width: false,
    //     last_updated: false
    // },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'opening-balance',
        field_name: 'BALANCE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];

export const INVOICE_TOURIST_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'invoice_type',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'invoice_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'client',
        field_name: 'CLIENT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'identity-card-number',
        field_name: 'ID_CODE',
        checked: true,
        order_by: 'id_code',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'invoice-date',
        field_name: 'INVOICE_DATE',
        checked: true,
        order_by: 'invoice_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'due',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'due_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'sent-date',
        field_name: 'SENT_DATE',
        checked: false,
        order_by: 'sent_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'reminder-date',
        field_name: 'REMINDER_DATE',
        checked: false,
        order_by: 'reminder_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_number',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    // {
    //     label: 'departs-the',
    //     field_name: 'DEPARTURE_DATE',
    //     checked: true,
    //     order_by: 'product_start_date',
    //     fixed_width: false,
    //     last_updated: false
    // },
    // {
    //     label: 'destination',
    //     field_name: 'DESTINATION',
    //     checked: false,
    //     order_by: 'destination',
    //     fixed_width: false,
    //     last_updated: false
    // },
    // {
    //     label: 'pax-number',
    //     field_name: 'PAX_NUMBER',
    //     checked: false,
    //     order_by: 'pax_number',
    //     fixed_width: false,
    //     last_updated: false
    // },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'opening-balance',
        field_name: 'BALANCE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];


export const INVOICE_VA_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'invoice_type',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'invoice_number',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'reference',
        field_name: 'REFERENCE',
        checked: true,
        order_by: 'insurance_contract__reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'subscription-method',
        field_name: 'SUBSCRIPTION_METHOD',
        checked: true,
        order_by: 'insurance_contract__contracts_type__name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'client',
        field_name: 'CLIENT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'invoice-date',
        field_name: 'INVOICE_DATE',
        checked: true,
        order_by: 'invoice_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'due',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'due_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'sent-date',
        field_name: 'SENT_DATE',
        checked: false,
        order_by: 'sent_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'reminder-date',
        field_name: 'REMINDER_DATE',
        checked: false,
        order_by: 'reminder_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    // {
    //     label: 'departs-the',
    //     field_name: 'DEPARTURE_DATE',
    //     checked: true,
    //     order_by: 'product_start_date',
    //     fixed_width: false,
    //     last_updated: false
    // },
    // {
    //     label: 'destination',
    //     field_name: 'DESTINATION',
    //     checked: false,
    //     order_by: 'destination',
    //     fixed_width: false,
    //     last_updated: false
    // },
    // {
    //     label: 'pax-number',
    //     field_name: 'PAX_NUMBER',
    //     checked: false,
    //     order_by: 'pax_number',
    //     fixed_width: false,
    //     last_updated: false
    // },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'opening-balance',
        field_name: 'BALANCE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];


export const INVOICE_PRODUCT_COLUMN_KEYS = [
    'trip-number',
    'departure-date',
    'name',
    'category',
    'destination',
    'quantity',
    'unit-price',
    'total-without-tax',
    'flight-tax',
    'amount',
    'description'
];

export const EMPTY_INVOICE_PRODUCT_COLUMN: InvoiceProductColumn[] = subDomain === "valeurs-assurances" ? [{
    key: 'contract',
    is_active: true
},
{
    key: 'departure-date',
    is_active: true
},
{
    key: 'category',
    is_active: true
},
{
    key: 'description',
    is_active: true
},
{
    key: 'destination',
    is_active: true
},
{
    key: 'quantity',
    is_active: true
},
{
    key: 'unit-price',
    is_active: true
},
{
    key: 'flight-tax',
    is_active: true
},
{
    key: 'amount',
    is_active: true
},

] : [
    {
        key: 'trip-number',
        is_active: true
    },
    {
        key: 'departure-date',
        is_active: true
    },
    {
        key: 'category',
        is_active: true
    },
    {
        key: 'description',
        is_active: true
    },
    {
        key: 'destination',
        is_active: true
    },
    {
        key: 'quantity',
        is_active: true
    },
    {
        key: 'unit-price',
        is_active: true
    },
    {
        key: 'flight-tax',
        is_active: true
    },
    {
        key: 'amount',
        is_active: true
    },
];

export const EMPTY_INVOICE_PRODUCT_COLUMN_WIDTH: Record<string, number> = {
    'trip-number': 130,
    'contract': 130,
    'type': 130,
    'departure-date': 150,
    'category': 150,
    'description': 250,
    'destination': 150,
    'quantity': 75,
    'unit-price': 130,
    'flight-tax': 130,
    'amount': 130
};

export const COLUMN_WIDTH: Record<string, number> = {
    'STATUS': 100,
    'SOURCE': 72,
    'TRIP_NUMBER': 100,
    'DEPARTURE_DATE': 120,
    'NB_PAX': 72,
    'INVOICE_NUMBER': 120,
    'COLLECTION': 130
};


export const PAID_COLUMN: Column[] = [
    {
        label: 'payment-date',
        field_name: 'DONE_DATE',
        checked: true,
        order_by: 'done_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'collection-number',
        field_name: 'COLLECTION_NUMBER',
        checked: true,
        order_by: 'identifier',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'description',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'payment-type',
        field_name: 'PAYMENT_TYPE',
        checked: true,
        order_by: 'payment_type',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_number',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'export-date',
        field_name: 'EXPORT_DATE',
        checked: true,
        order_by: 'export_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];



export const PAID_VA_COLUMN: Column[] = [
    {
        label: 'payment-date',
        field_name: 'DONE_DATE',
        checked: true,
        order_by: 'done_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'collection-number',
        field_name: 'COLLECTION_NUMBER',
        checked: true,
        order_by: 'identifier',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'description',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'payment-type',
        field_name: 'PAYMENT_TYPE',
        checked: true,
        order_by: 'payment_type',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'reference',
        field_name: 'REFERENCE',
        checked: true,
        order_by: 'insurance_contract__reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'subscription-method',
        field_name: 'SUBSCRIPTION_METHOD',
        checked: true,
        order_by: 'insurance_contract__contracts_type__name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'export-date',
        field_name: 'EXPORT_DATE',
        checked: true,
        order_by: 'export_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];

export const EMPTY_THIRD_PARTY: ThirdParty = {
    id: 0,
    name: "",
    code: "",
    user: null
};

export const EMPTY_THIRD_PARTY_FILTERS: ThirdPartyListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_THIRD_PARTY_LIST_CRITERIA: SalesReceiptThirdPartyListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_THIRD_PARTY_FILTERS,
    search: '',
    client_branch: null
};

export const THIRD_PARTY_COLUMN: Column[] = [
    {
        label: 'code',
        field_name: 'CODE',
        checked: true,
        order_by: 'code',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'export-date',
        field_name: 'EXPORT_DATE',
        checked: true,
        order_by: 'export_date',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }
];

export const EMPTY_THIRD_PARTY_LIST_CONFIGURATION: SalesReceiptListConfiguration = {
    columns: THIRD_PARTY_COLUMN,
    preferences: []
};

export const EMPTY_SALES_RECEIPT_LIST_CONFIGURATION: SalesReceiptListConfiguration = {
    columns: subDomain === "valeurs-assurances" ? DEFAULT_VA_COLUMN : subDomain === 'tourist-forum'? DEFAULT_TOURIST_COLUMN : DEFAULT_COLUMN,
    preferences: []
};


export const EMPTY_SALES_RECEIPT_CLIENT_LIST_CONFIGURATION: SalesReceiptListConfiguration = {
    columns: CLIENT_COLUMN,
    preferences: []
};

export const EMPTY_SALES_RECEIPT_INVOICE_LIST_CONFIGURATION: SalesReceiptListConfiguration = {
    columns: subDomain === "valeurs-assurances" ? INVOICE_VA_COLUMN : subDomain === 'tourist-forum'? INVOICE_TOURIST_COLUMN : INVOICE_COLUMN,
    preferences: []
};


export const EMPTY_SALES_RECEIPT_PAID_LIST_CONFIGURATION: SalesReceiptListConfiguration = {
    columns: subDomain === "valeurs-assurances" ? PAID_VA_COLUMN : PAID_COLUMN,
    preferences: []
};

export const SALES_RECEIPT_MODULE = 'SALES_RECEIPT_MODULE';
export const SALES_FORECAST_MODULE = 'SALES_FORECAST_MODULE';
export const SALES_CLIENT_MODULE = 'SALES_CLIENT_MODULE';
export const SALES_UNPAID_MODULE = 'SALES_UNPAID_MODULE';
export const SALES_INVOICE_MODULE = 'SALES_INVOICE_MODULE';
export const SALES_PAID_MODULE = 'SALES_PAID_MODULE';
export const SALES_THIRD_PARTY_MODULE = 'SALES_THIRD_PARTY_MODULE';

